/** @see DesignModuleLocalVariable.props.config.type. */
export enum VariableType {
  array = 'ARRAY',
  boolean = 'BOOLEAN',
  module = 'MODULE',
  number = 'NUMBER',
  object = 'OBJECT',
  prompt = 'PROMPT',
  string = 'STRING'
}
